import React, { createContext, useContext, useEffect, useState } from 'react';
import { getTodaysDate } from 'services/Api';

const ServerDateContext = createContext(null);

export const useServerDate = () => useContext(ServerDateContext);

export const ServerDateProvider = ({ children }) => {
  const [serverDate, setServerDate] = useState(null);

  useEffect(() => {
    async function fetchDate() {
      try {
        const result = await getTodaysDate(); 
        const [year, month, day] = result.split('-');
        setServerDate(new Date(year, month - 1, day));
      } catch {
        setServerDate(new Date()); // Fallback
      }
    }
    fetchDate();
  }, []);

  if (!serverDate) return null; // or show loading

  return (
    <ServerDateContext.Provider value={serverDate}>
      {children}
    </ServerDateContext.Provider>
  );
};